// @see https://www.nrk.no/telemark/norges-eldste-bedrift-fyller-350-ar-1.3129230
export const NORGES_ELDSTE_BEDRIFT_AAR_STIFTET = 1657;

export const ROLLE_RAADGIVER = 'RAADGIVER';
export const SPORSMAL_PAKREVET = 'PAKREVET';
export const PAKREVET_HVIS_FORELDER = 'PAKREVET_HVIS_FORELDER';
export const BARE_LES_NAR_VALGT = 'BARE_LES_NAR_VALGT';
export const KUN_LESING = 'KUN_LESING';

export const SPORSMALSTYPE_AKTOR = 'aktor';
export const SPORSMALSTYPE_AKTOR_CAP = 'AKTOR';
export const SPORSMALSTYPE_AKTOR_LIST = 'aktor_list';
export const SPORSMALSTYPE_AKTOR_LIST_CAP = 'AKTOR_LIST';
export const SPORSMALSTYPE_DISPONENT_LIST = 'disponent_list';
export const SPORSMALSTYPE_DISPONENT_LIST_CAP = 'DISPONENT_LIST';
export const SPORSMALSTYPE_CHECKBOX = 'checkbox';
export const SPORSMALSTYPE_CHECKBOX_CAP = 'CHECKBOX';
export const SPORSMALSTYPE_CRS = 'CRS';
export const SPORSMALSTYPE_CRS_CAP = 'CRS';
export const SPORSMALSTYPE_CRS_V2_CAP = 'CRS_V2';
export const SPORSMALSTYPE_FATCA_V2_CAP = 'FATCA_V2';
export const SPORSMALSTYPE_CRS_V2_DETAILS_CAP = 'CRS_V2_DETAILS';
export const SPORSMALSTYPE_FATCA_V2_DETAILS_CAP = 'FATCA_V2_DETAILS';
export const SPORSMALSTYPE_LAND = 'land';
export const SPORSMALSTYPE_LAND_CAP = 'LAND';
export const SPORSMALSTYPE_NUMBER = 'number';
export const SPORSMALSTYPE_NUMBER_CAP = 'NUMBER';
export const SPORSMALSTYPE_AMOUNT = 'amount';
export const SPORSMALSTYPE_AMOUNT_CAP = 'AMOUNT';
export const SPORSMALSTYPE_RADIO = 'radio';
export const SPORSMALSTYPE_RADIO_CAP = 'RADIO';
export const SPORSMALSTYPE_RADIO_CLASSIC = 'radio_classic';
export const SPORSMALSTYPE_RADIO_CLASSIC_CAP = 'RADIO_CLASSIC';
export const SPORSMALSTYPE_SELECT = 'select';
export const SPORSMALSTYPE_SELECT_CAP = 'SELECT';
export const SPORSMALSTYPE_TEXT = 'text';
export const SPORSMALSTYPE_TEXT_CAP = 'TEXT';
export const SPORSMALSTYPE_TEXT_AREA = 'text_area';
export const SPORSMALSTYPE_TEXT_AREA_CAP = 'TEXT_AREA';
export const SPORSMALSTYPE_DATE_CAP = 'DATE';
export const SPORSMALSTYPE_TEXT_LIST = 'text_list';
export const SPORSMALSTYPE_TEXT_LIST_CAP = 'TEXT_LIST';
export const SPORSMALSTYPE_INTERNASJONALE_OVERFORINGER = 'internasjonale_overforinger';
export const SPORSMALSTYPE_INTERNASJONALE_OVERFORINGER_CAP = 'INTERNASJONALE_OVERFORINGER';
export const SPORSMALSTYPE_RR_CAP = 'AKTOR_RR';

export const SPORSMAL_SYSTEM = 'SYSTEM';

export const BM_AKTOR_RR_YES_VALUE = 'r-110-1';
export const BM_AKTOR_RR_NO_VALUE = 'r-110-2';
